"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIMARY_STORAGE_KEY_COOKIE = exports.FIREBASE_ID_TOKEN_COOKIE = void 0;
/* Be careful, this is a contract with some native apps */
exports.FIREBASE_ID_TOKEN_COOKIE = 'FIREBASE_ID_TOKEN';
exports.PRIMARY_STORAGE_KEY_COOKIE = 'PRIMARY_STORAGE_KEY';
